import { useCallback } from "react";
import { useContentModals } from "../contexts/contentModalsContext";
import { useDispatchApp } from "../lib/redux";
import { getPathDatabaseByRole } from "../actions/auth";
import {
  ADS_CAMPAIGN_CAROUSEL_FORMAT,
  IMAGE_FORMATS,
  VIDEO_FORMATS,
} from "../utils/constants";
import { PENDING_CONTENT_APPROVAL_REVIEW_STORAGE_KEY } from "../components/ContentApproval/contentApprovalUtils";

const useOutsideCampaignGallery = () => {
  const { openGallery } = useContentModals();
  const dispatch = useDispatchApp();
  const { userID } = dispatch(getPathDatabaseByRole());

  const onOpenGallery = useCallback(
    ({
      initialPreviewItemID: previewItemID,
      initialPreviewCarouselIndex: previewCarouselIndex,
      initialGalleryEditAction,
      initialGalleryEditResize,
    } = {}) => {
      const pendingContentID = sessionStorage.getItem(
        PENDING_CONTENT_APPROVAL_REVIEW_STORAGE_KEY
      );

      if (pendingContentID) {
        sessionStorage.removeItem(PENDING_CONTENT_APPROVAL_REVIEW_STORAGE_KEY);
      }

      openGallery({
        multiple: true,
        isOutsideCampaign: true,
        acceptedFormats: IMAGE_FORMATS.concat(VIDEO_FORMATS).concat(
          ADS_CAMPAIGN_CAROUSEL_FORMAT
        ),
        pathStorage: `socialMedia/${userID}/`,
        modeUpload: "sync",
        onCallbackSelectedItems: () => {},
        closeActionsDisabled: true,
        initialContentReviewID: pendingContentID || null,
        ...(previewItemID
          ? { initialPreviewItemID: String(previewItemID) }
          : {}),
        ...(previewCarouselIndex != null
          ? { initialPreviewCarouselIndex: Number(previewCarouselIndex) }
          : {}),
        ...(initialGalleryEditAction ? { initialGalleryEditAction } : {}),
        ...(initialGalleryEditResize ? { initialGalleryEditResize } : {}),
      });
    },
    [openGallery, userID]
  );

  return {
    onOpenGallery,
  };
};

export default useOutsideCampaignGallery;
